import React from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from '@material-ui/core/TextField';
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Calendar from "@material-ui/icons/CalendarToday";
import List from "@material-ui/icons/ListAlt";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import InfoArea from "beaktShared/components/InfoArea/InfoArea.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import FormHelperText from "@material-ui/core/FormHelperText";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// services
import { MaskCPF, MaskCNPJ} from "beaktShared/helpers/masks";
import { UsePostApiLogin, UseGetApiSimpleAnonymous} from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
const useStyles = makeStyles(styles);

export default function RegisterPage({ history }) {
  const { t } = useTranslation();
  
  const classes = useStyles();
  const { register, handleSubmit, errors } = useForm({mode: "onBlur"});
  const [isLoadingCNPJ, setisLoadingCNPJ] = React.useState(false);
  const [registroFinalizado, setregistroFinalizado] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [aceitaTermosCheckbox, setaceitaTermosCheckbox] = React.useState(false);

  const [messageg, setmessageg] = React.useState({
    exist: false,
    message: "",
    type: "error"
   });
  
  const hangleshowMessage = (exist,message,type) =>{
    setmessageg({
      exist: exist,
      message: message,
      type: type
    });
  }

  const [labelCNPJCPF, setlabelCNPJCPF] = React.useState('CNPJ *');
  const [selectedValue, setSelectedValue] = React.useState('cnpj');
  const handleChange = event => {
    setSelectedValue(event.target.value);
    if(event.target.value==='cpf')
      setlabelCNPJCPF(t('label.cpf')+" *")
    else    
      setlabelCNPJCPF(t('label.cnnpj')+" *")
  };

  const handleCNPJChange = (e) =>{
  
    hangleshowMessage(false,'','');   
         
    var cnpj =  e.target.value.replace(".","").replace(".","").replace("/","").replace("-","");
    if(cnpj === "")
    return;

    setisLoadingCNPJ(true); 
    const endPoint = "estabelecimentos/verifycnpjexists/"+cnpj;
    UseGetApiSimpleAnonymous(endPoint).then(result=>{       
        if(result.status !== 200)
        {                                     
            hangleshowMessage(true, result.message, 'error')      
            setisLoadingCNPJ(false);
            return false; 
        }      
                     
        if(result.data === true)
          hangleshowMessage(true, selectedValue.toUpperCase()+ t('error_message.is_already_registered_in_the_system'), 'error')     
  
        setisLoadingCNPJ(false);   
        return true;                
    }); 
  
  }

  const Login = () =>
  {
    setTimeout(()=> {    
      history.push("/institutionalday/login")
    }, 100)  
  }

  const onSubmit = (data)=> {
  
    hangleshowMessage(false,'','');
   
    if(!aceitaTermosCheckbox)
    {
      hangleshowMessage(true, t('error_message.it_is_necessary_to_accept_the_terms_and_conditions'), 'error')  
      return;  
    }

    setLoading(true);

    var obj = {   
        dociscnpj: selectedValue==='cnpj' ? true : false,
        cnpjcpf: data.cnpjcpf,
        descricao: data.descricao,
        email: data.email
    }    
    
    let endPoint = 'estabelecimentos/registrese';
    UsePostApiLogin(endPoint, obj).then(result=>{

        if(result.status !== 200)
        {  
            hangleshowMessage(true, result.message, 'error');     
            setLoading(false);
            return false; 
        } 
           
        setregistroFinalizado(true);

        setLoading(false);        
        return true;   
    });
};

  return (
    <div className={classes.container}>
    <br/><br/>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={10}>
          <Card className={classes.cardSignup}>
            <h2 className={classes.cardTitle}>{t('register.say_goodbye_to_papers_welcome_to')} {1900 + new Date().getYear()}</h2>
            <CardBody>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={5}>
                  <InfoArea
                    title={t('label.indicators')}
                    description={t('register.manage_your_time')}
                    icon={Timeline}
                    iconColor="primary"
                  />
                  <InfoArea
                    title={t('label.calendar')}
                    description={t('register.see_your appointments')}
                    icon={Calendar}
                    iconColor="info"
                  />
                  <InfoArea
                    title=
                    {t('label.services')}
                    description={t('register.register_your_services')}
                    icon={List}
                    iconColor="rose"
                  />
                </GridItem>
                <GridItem xs={12} sm={8} md={5}>
                  
                {!registroFinalizado &&  
                <form onSubmit={handleSubmit(onSubmit)} >

                <FormControlLabel
                      control={
                        <Radio
                          checked={selectedValue === "cnpj"}
                          onChange={handleChange}
                          value="cnpj"
                          name="CNPJ"
                          aria-label={t('label.cnpj')}
                          icon={
                            <FiberManualRecord
                              className={classes.radioUnchecked}
                            />
                          }
                          checkedIcon={
                            <FiberManualRecord
                              className={classes.radioChecked}
                            />
                          }
                          classes={{
                            checked: classes.radio,
                            root: classes.radioRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label={t('label.cnpj')}
                    />
                <FormControlLabel
                  control={
                    <Radio
                      checked={selectedValue === "cpf"}
                      onChange={handleChange}
                      value="cpf"
                      name="cpf"
                      aria-label={t('label.cpf')}
                      icon={
                        <FiberManualRecord
                          className={classes.radioUnchecked}
                        />
                      }
                      checkedIcon={
                        <FiberManualRecord
                          className={classes.radioChecked}
                        />
                      }
                      classes={{
                        checked: classes.radio,
                        root: classes.radioRoot
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                    root: classes.labelRoot
                  }}
                  label={t('label.cpf')}
                />

                <FormControl fullWidth className={classes.formControl}>                               
                      <TextField                                        
                          error={errors.cnpjcpf?true:false}
                          inputRef={register({required: true})}
                          name="cnpjcpf"
                          onBlur={handleCNPJChange}
                          label={labelCNPJCPF}
                          InputProps={{
                            inputComponent: selectedValue === "cpf" ? MaskCPF : MaskCNPJ,
                            endAdornment: (
                              <InputAdornment>
                                {isLoadingCNPJ && <LoadingIcon className="rotate" />}
                              </InputAdornment>
                            ),
                            autoComplete: "off"
                          }}
                          inputProps={{ maxLength: 150}}
                      /> 
                  </FormControl> 
                  
                <FormControl fullWidth className={classes.formControl}>                               
                    <TextField                                        
                        error={errors.descricao?true:false}
                        inputRef={register({required: true})}
                        name="descricao"
                        label={t('label.description')}
                        inputProps={{ maxLength: 150}}
                    />  
                </FormControl>  

                <FormControl fullWidth className={classes.formControl}>                               
                    <TextField                                        
                        error={errors.email?true:false}
                        inputRef={register({
                          required: t('label.required'),
                          pattern: {
                            value: /^\S+@\S+$/i,
                            message: t('label.invalid_email')
                          },
                          maxLength: {
                              value:150,
                              message: t('label.enter_a_maximum_of_150_characters')
                          }
                        })} 
                        name="email"
                        label={t('label.email')+" *"}
                        inputProps={{ maxLength: 50}}
                    /> 
                </FormControl>   
                   
                <FormControlLabel
                      classes={{
                        root: classes.checkboxLabelControl,
                        label: classes.checkboxLabel
                      }}
                      control={
                        <Checkbox
                          checked={aceitaTermosCheckbox}   
                          onClick={event => {setaceitaTermosCheckbox(event.target.checked)}}
                          checkedIcon={ <Check className={classes.checkedIcon} /> }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                          inputRef={register}  
                        />
                      }
                      label={
                        <span>
                         {t('register.i_accept_the')} {" "}
                          <a href="#teste" >{t('register.terms_and_conditions')} </a>.
                        </span>
                      }
                />

                <br/>
                
                {errors.descricao &&<FormHelperText className={classes.labelRootError}>
                      <span>{t('label.required')} </span>
                </FormHelperText> 
                }
                {errors.cnpjcpf &&<FormHelperText className={classes.labelRootError}>
                    <span>{selectedValue.toUpperCase()}{t('label.required')} </span>
                </FormHelperText>
                }
                {errors.email && <FormHelperText className={classes.labelRootError}>
                    <span>{errors.email.message}</span>
                </FormHelperText>  
                }
                {messageg.exist &&<b className={messageg.type==='error' ? classes.labelRootError : classes.labelRootSuccess}>
                      <span> {messageg.message} </span>
                </b> 
                }

                <div className={classes.center}>
                  <Button type="submit"  round color="primary">
                    {t('register.register')} {loading && <label> <LoadingIcon className="rotate rsmall" /></label>}  
                  </Button>
                      
                    <br/><br/><br/> <a href="/institutionalday/login">{t('login.already_have_an_account_machete')} <b>{t('login.login')} </b></a>
                    </div>
                  </form>
              }

              {registroFinalizado &&
                
                <div>
                  
                  <br/> 
                  <br/>
                  <b className={classes.labelRootSuccess}>
                        <span> {t('login.registration_successful')+"!"}
                          <br/> {t('login.log_in_with')} {selectedValue.toUpperCase()}{t('login.informed_and_set_your_password')} </span>
                  </b> 
                  <br/> 
                  <br/>
                  

                  <Button onClick={Login} round color="primary">
                   {t('login.log_in')}
                  </Button>
                </div>
              }

                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
